export enum CodesVersion {
  VERSION_1_5 = "VERSION_1_5",
  VERSION_1_6 = "VERSION_1_6",
  VERSION_1_7 = "VERSION_1_7",
  VERSION_1_8 = "VERSION_1_8",
}
